import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import _ from "lodash";

const Select = ({
  options = [],
  selected,
  onSelect,
  placeholder = "בחר",
  multi = false,
  closeOnSelect = true,
  isSearchable = false
}) => {
  const [mappedOptions, setMappedOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(multi ? [] : null);

  useEffect(() => {
    const mapped = options.map((item) => ({
      value: item.id,
      label: item.description
    }));
    setMappedOptions(mapped);

    if (selected) {
      if (multi) {
        const filtered = mapped.filter((item) => selected.includes(item.value));
        setSelectedOption(filtered);
      } else {
        const found = mapped.find((item) => item.value === selected);
        setSelectedOption(found || null);
      }
    } else {
      setSelectedOption(multi ? [] : null);
    }
  }, [options, selected, multi]);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);

    if (multi) {
      const values = selectedOption.map((item) => item.value);
      onSelect && onSelect(values);
    } else {
      const value = selectedOption ? selectedOption.value : null;
      onSelect && onSelect(value);
    }
  };

  return (
    <div style={{ minWidth: "200px" }}>
      <ReactSelect
        isMulti={multi}
        rtl={true}
        name="form-field-name"
        value={selectedOption}
        onChange={handleChange}
        options={mappedOptions}
        isSearchable={isSearchable}
        placeholder={placeholder}
        closeMenuOnSelect={closeOnSelect}
      />
    </div>
  );
};

export default Select;
